import React, { useRef, useState } from 'react';

import { CommentFormModalContext } from '../../utils/contexts';
import { Container, Modal, Content, FormRow, Button } from '../../styles/modals/generic-modal';
import Header from './parts/modal-header';
import { postCommentForm } from '../../utils/requests';

export default function CommentFormModal(props) {

	const nameRef = useRef(null);
	const emailRef = useRef(null);
	const phoneRef = useRef(null);
	const messageRef = useRef(null);

	const [ isSubmitting, setIsSubmitting ] = useState(false);
	
	const handleFormSubmit = (e, postUrl) => {
		e.persist();
		e.preventDefault();
		
		const data = {
			name: nameRef.current.value,
			email: emailRef.current.value,
			phone: phoneRef.current.value,
			message: messageRef.current.value
		};
		
		setIsSubmitting(true);
		const request = postCommentForm(postUrl, data);
		request
			.finally(() => {
				setIsSubmitting( is => false);
			});
	}

	return(
		<CommentFormModalContext.Consumer>
			{
				({ isOpen, postUrl, setIsOpen }) => {

          if (isOpen) {
            window.history.pushState(null, null, window.location.pathname);
            window.addEventListener('popstate', (e) => {
              e.preventDefault();
              setIsOpen(false)
            });
          }

					return <Container visible={isOpen} className="bg" onClick={(e) => e.target.classList.contains('bg') && setIsOpen(false)}>
						<Modal>
							<Header onCloseClick={() => setIsOpen(false)} />
							<Content className="pad scrollable">
								<h3>Comment Form</h3>
								<p>Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.</p>
								<form
									className="comment-form"
									onSubmit={(e) => handleFormSubmit(e, postUrl)}
								>
									<FormRow>
										<label htmlFor="name">Name</label>
										<input ref={nameRef} name="name" type="text" />
									</FormRow>
									<FormRow>
										<label htmlFor="email" >Email</label>
										<input ref={emailRef} name="email" type="email" />
									</FormRow>
									<FormRow>
										<label htmlFor="phone" >Phone</label>
										<input ref={phoneRef} name="phone" type="tel" />
									</FormRow>
									<FormRow>
										<label htmlFor="message" >Message</label>
										<textarea ref={messageRef} name="message" rows={4} />
									</FormRow>
									<FormRow>
										<div className="left-spacer" ></div>
										<div className="right-spacer" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }} >
											<Button type="submit" disabled={isSubmitting} >Submit</Button>
										</div>
									</FormRow>
								</form>
							</Content>
						</Modal>
					</Container>
        }
			}
		</CommentFormModalContext.Consumer>
	);
}